import 'reflect-metadata';
//---

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { reportBootstrapError } from './app/global-error/global-error-handler.service';

bootstrapApplication(AppComponent, appConfig).catch((err) => reportBootstrapError(err));
